import { useSyncExternalStore } from "react";

/** Matches Figma: QR on tablet/desktop (≥768); store badges below that width. */
const MEDIA_QUERY = "(min-width: 768px)";

function subscribe(onStoreChange: () => void) {
  const mq = window.matchMedia(MEDIA_QUERY);
  const listener = () => onStoreChange();
  mq.addEventListener("change", listener);
  return () => mq.removeEventListener("change", listener);
}

function getSnapshot() {
  return window.matchMedia(MEDIA_QUERY).matches;
}

/** SSR / test fallback: prefer QR + card (matches desktop-first paint). */
function getServerSnapshot() {
  return true;
}

export function useIsMinWidth768(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
